import { ExpertDataQuery } from 'shared/hooks/api/expertData/expertData.generated';
import { ExtractionStateEnum } from 'types/enums/extraction-state.enum';
import { create } from 'zustand';

interface HubStateType {
  finishedAt: Date | null;
  extractionState: ExtractionStateEnum | null;
  cvReuploadAvailable: boolean;
}

interface OnboardingStoreType extends HubStateType {
  setOnboardingFinishedAt: (
    finishedAt: Date | null,
    extractionState?: ExtractionStateEnum | null,
  ) => void;
  setExtractionState: (extractionState: ExtractionStateEnum | null) => void;
  loadHubStateData: (onboardingState: ExpertDataQuery['expertHubState']) => void;
}

export const useHubStateStore = create<OnboardingStoreType>((set) => ({
  extractionState: null,
  finishedAt: null,
  cvReuploadAvailable: false,
  setOnboardingFinishedAt: (
    finishedAt: Date | null,
    extractionState?: ExtractionStateEnum | null,
  ) => set(() => ({ finishedAt, ...(extractionState && { extractionState }) })),
  setExtractionState: (extractionState: ExtractionStateEnum | null) =>
    set(() => ({ extractionState })),
  loadHubStateData: (dto: ExpertDataQuery['expertHubState']) => {
    set(() => ({
      finishedAt: dto?.onboardingFinishedAt || null,
      extractionState: (dto?.extractionState as unknown as ExtractionStateEnum) || null,
      cvReuploadAvailable: dto?.cvReuploadAvailable,
    }));
  },
}));
